<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="form-double-description control-group">
    <div
      class="first-column"
      v-html="interpolatedFirstColumn"
    />
    <div
      class="second-column"
      v-html="interpolatedSecondColumn"
    />
  </div>
</template>

<script>
import formatWysiwyg from '../../utils/format_wysiwyg';

export default {
  name: 'FormDoubleDescription',

  schema: [
    {
      name: 'first-column',
      default: 'Alinea met uitleg',
      type: 'FormTextarea',
      label: 'Eerste column',
    },
    {
      name: 'second-column',
      default: 'Alinea met uitleg',
      type: 'FormTextarea',
      label: 'Tweede column',
    },
    {
      name: 'extra-values',
      default: 'Alinea met uitleg',
      type: 'FormDescription',
      description:
        'Deze sleutelwoorden zijn te gebruiken om delen in de tekst dynamisch te maken en op te vullen met informatie uit een project. \n \
\n \
Algemeen: \n \
{{datum_en_tijd_van_invullen}}\n \
{{datum_van_invullen}}\n \
{{kantoor_kvk_nummer}}\n \
\n \
Project specifiek: \n \
{{project_adres}}\n \
{{project_hoogste_risicoklasse}}\n \
{{project_naam}}\n \
{{project_referentie}}\n \
{{project_werkplan_revisie}}\n \
\n \
Verantwoordelijken: \n \
{{dta_of_voorman_naam}}\n \
{{dta_of_voorman_sca}}\n \
\n \
Partijen: \n \
{{inspectie_instelling_naam}}\n \
{{onderzoeksbureau_naam}}\n \
{{opdrachtgever_adres}}\n \
{{opdrachtgever_contactpersoon}}\n \
{{opdrachtgever_naam}}\n \
{{saneringsbedrijf_adres}}\n \
{{saneringsbedrijf_naam}}\n \
{{saneringsbedrijf_sca}}\n \
\n \
Documenten: \n \
{{inventarisatierapport_datum}}\n \
{{inventarisatierapport_omschrijving}}\n \
{{sloopmelding_datum}}\n \
{{sloopmelding_omschrijving}}\n \
\n \
Speciale velden getriggert door parameters \n \
{{param_geregistreerde_tijd_werknemer_naam}} \n \
',
    },
  ],

  props: {
    firstColumn: {
      type: String,
      default: '',
    },
    secondColumn: {
      type: String,
      default: '',
    },
    assigns: {
      type: Object,
      default: () => ({}),
    },
    environment: {
      type: String,
      required: true,
    },
  },

  computed: {
    interpolatedFirstColumn() {
      if (Object.keys(this.assigns).length === 0) return this.firstColumn;
      return formatWysiwyg(this.firstColumn.replace(
        /{{(\w*)}}/g,
        (_, key) => this.assigns[key] || `Onbekend veld: ${key}`,
      ));
    },
    interpolatedSecondColumn() {
      if (Object.keys(this.assigns).length === 0) return this.secondColumn;
      return formatWysiwyg(this.secondColumn.replace(
        /{{(\w*)}}/g,
        (_, key) => this.assigns[key] || `Onbekend veld: ${key}`,
      ));
    },
  },
};
</script>

<style lang="scss">
.form-double-description {
  display: flex;
  flex-grow: 1;
  padding-left: 40px;

  p {
    font-size: 14px;
    line-height: 20px;
    padding: 5px 0;
    white-space: pre-wrap;
  }

  .first-column {
    width: 50%;
    text-align: left;
    margin-right: 20px;

    p {
      margin: 0;
    }
  }

  .second-column {
    width: 50%;

    p {
      margin: 0;
    }
  }
}

.wp-form-modal {
  .form-double-description {
    max-height: 300px;
    overflow: auto;
  }
}
</style>
